import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GroupModel } from 'src/app/components/configuration/models/groupModel';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-addeditconfigurationgroup',
  templateUrl: './configurationgroup.add.component.html'
})
export class AddeditconfigurationgroupComponent implements OnInit {
  submitted: boolean = false;
  group: GroupModel = new GroupModel();
  productCode = new FormControl('', [Validators.required]);
  groupName = new FormControl('', [Validators.required]);

  constructor(public dialogRef: MatDialogRef<AddeditconfigurationgroupComponent>, @Inject(MAT_DIALOG_DATA) public groupData: GroupModel, public _restAPI: RestAPIService)
  {
    this._restAPI.loading  = false;
    this.group = JSON.parse(JSON.stringify(groupData));
  }
    
  async ngOnInit() {
    //init form controls
  }

  closeDialog(): void {
      this.dialogRef.close(false);
  }

  async saveProduct() {
      this.submitted = true;
      if(!this.productCode.invalid && !this.groupName.invalid){
          this._restAPI.loading  = true;
          if (this.group.groupId != null && this.group.groupId.length > 0 && this.group.groupId != '00000000-0000-0000-0000-000000000000') {
              let putData = {
                  groupId : this.group.groupId,
                  productCode: this.group.productCode,
                  groupName: this.group.groupName,
              };
              this._restAPI.put<string>(environment.apiURL + 'api/configurationgroup/'+ this.group.groupId, putData).subscribe({
                  next: (data) => {
                    this._restAPI.loading  = false;
                    this.dialogRef.close(true);
                  },
                  error: (error) => {this._restAPI.loading  = false;console.error(error)}
              });
          }
          else {
              let postData = {
                  productCode: this.group.productCode,
                  groupName: this.group.groupName,
              };
              this._restAPI.post<string>(environment.apiURL + 'api/configurationgroup', postData).subscribe({
                  next: (data) => {
                    this._restAPI.loading  = false;
                    this.dialogRef.close(true);
                  },
                  error: (error) => {this._restAPI.loading  = false;console.error(error)}
              });
          }
      }
  }
}
